import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { StoreService } from 'src/app/shared/services/store.service';

@Injectable({ providedIn: 'root' })
export class D2cStorageService {
    private storageKey = 'cibilStageData';
    private stageSubject = new BehaviorSubject<any>(null);
    stage$ = this.stageSubject.asObservable();

    constructor(private storeService: StoreService) {
        const stored = this.storeService.get(this.storageKey);
        if (stored) {
            try {
                this.stageSubject.next(JSON.parse(stored));
            } catch (err) {
                console.error('⚠️ Invalid cached D2C data in store:', err);
            }
        }
    }

    /** 🔹 Update BehaviorSubject + store */
    set(value: any) {
        if (!value) return;

        this.stageSubject.next(value);

        this.storeService.set({
            key: this.storageKey,
            value: JSON.stringify(value)
        });
    }

    /** 🔹 Get current value synchronously */
    get(): any {
        return this.stageSubject.getValue();
    }

    /** 🔹 Observable for real-time updates */
    watch(): Observable<any> {
        return this.stage$;
    }

    /** 🔹 Clear all cached D2C stage data */
    clear(): void {
        this.stageSubject.next(null);
        this.storeService.set({
            key: this.storageKey,
            value: ''
        });
    }
}
